import React, { useEffect } from 'react';
import { ParosProvider, useParos } from './ParosContext';
// import Llamados from '../../components/Llamados/Llamados';
import '../../styles/paros.css';
import Cookies from 'universal-cookie';
import CategoParos from './CategoParos';
import ModalP from '../../components/ModalP';
import ModalM from '../../components/ModalM';
import ModalConfirm from '../../components/ModalConfirm';
import { makeStyles, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { useGeneral } from '../../Context/GeneralContext';
import SelecTCelda from '../../components/SelectCelda/SelectCelda';
import { useHistory } from 'react-router-dom';


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '820px',
        display: 'block',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
}));

function Paros() {
    const { dias, meses } = useParos();
    const { openSnack, setOpenSnack, mensaje, tipoMensaje, setInParosView } = useGeneral();
    const cookie = new Cookies();
    const classes = useStyles();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    useEffect(() => {
        setInParosView(true);
    }, [setInParosView]);

    return (
        <div className="parosView">
            <div className="parosView-head">
                <div className="parosView-head-title">
                    <h1 className="parosView-head-titulo">Paros</h1>
                    <h4>
                        {dias[new Date().getDay()]}
                        {', '}
                        {new Date().toISOString().slice(8, 10)} {meses[new Date().getMonth()]}{' '}
                        {new Date().toISOString().slice(0, 4)}
                    </h4>
                    <p className="parosView-head-desc">{cookie.get('nombreL')}</p>
                </div>
                {/* <Llamados /> */}
                <SelecTCelda flag={0} />
            </div>
            <div className="parosView-body">
                <CategoParos />
            </div>
            <ModalP />
            <ModalM />
            <ModalConfirm />
            <div className={classes.root}>
                <Snackbar
                    className={classes.root}
                    open={openSnack}
                    autoHideDuration={3000}
                    onClose={handleClose}
                >
                    <Alert onClose={handleClose} severity={tipoMensaje}>
                        {mensaje}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    );
}

let ParosProviderComp = () => {
    let history = useHistory();
    if (!process.env.REACT_APP_ALLOW_PAROS_VIEW) {
        history.replace('/');
        return <></>;
    }
    return (
        <ParosProvider>
            <Paros></Paros>
        </ParosProvider>
    );
};

export default ParosProviderComp;

